import { render, staticRenderFns } from "./Agriculture.vue?vue&type=template&id=1c4f8ae9&scoped=true"
import script from "./Agriculture.vue?vue&type=script&lang=js"
export * from "./Agriculture.vue?vue&type=script&lang=js"
import style0 from "./Agriculture.vue?vue&type=style&index=0&id=1c4f8ae9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c4f8ae9",
  null
  
)

export default component.exports